import React, { Component } from 'react';
import {
  userLessonStateList
} from './staticData.js';
import Header from './header'
import Medal from './medal'
import MyWeal from './myWeal'
import Server from '../../common/server';
import './index.scss';
import { createHashHistory } from 'history'

class Achievement extends Component {
  constructor(props, context){
    super(props)
    this.state = {
      avatar: '',
      medalData: [],
      gradeInfo: [],
      level: '',
      difListenCount: '',
      listenCount: '',
      dark: false
    }
  }
  componentDidMount(){
    let me = this
    this.init()
    window.setYDUIStyle = function setYDUIStyle(params) {
      if (params === 'dark') {
        me.setState({
          dark: true,
          userStateImg: userLessonStateList.darkStatus,
        })
      } else {
        me.setState({
          dark: false,
          userStateImg: userLessonStateList.lightStatus
        })
      }
    }
    window.setYDUIStyle(navigator.userAgent.indexOf('YDUIStyle/Dark') > -1 ? 'dark':'light')
  }
  init(reset) {
    var me = this
    Server.getUserInfo(function (json) {
      let medalData = []
      let arr = []
      let vip = false
      json.data.awards.forEach((item, index) => {
        if ((index + 1) % 3 === 0) {
          arr.push(item)
          medalData.push(arr)
          arr = []
        } else {
          arr.push(item)
        }
      })
      // 这么处理的原因是为了适配，ipad，ipad横屏也是每行展示三个
      json.data.awards.forEach((item, index) => {
        if (item.id === "vipAward" && item.unlock) {
          vip = true
        } else if (item.id === "vipAward" && !item.unlock) {
          vip = false
        }
      })
      me.setState({
        vip: vip,
        avatar: json.data.avatar,
        medalData: medalData,
        medalDataLength: json.data.awards.length,
        gradeInfo: json.data.gradeInfo,
        level: json.data.level,
        difListenCount: json.data.difListenCount,
        listenCount: json.data.listenCount
      })
      me.refs.header.initRender(json.data.level)
      if (reset) {
        me.refs.myWeal.init()
      }
    })
  }
  render() {
    return (
      <div className={ this.state.dark ? 'dark contact':'light contact'}>
        <div className="achievement color-bg-1">
          <div className="tab color-bg-tab">
            <img className="back" src="http://ydschool-online.nos.netease.com/1571214591045ic_back%402x.png" onClick={() => window.ydk.closeCurrentPage()} />
            <a className="strategy" href="http://shared.youdao.com/dict/market/audio_promotion_strategy/index.html" title="asdasdasdasd">晋升攻略</a>
          </div>
          <Header ref="header" vip={this.state.vip} resetData={this.init.bind(this)} avatar={this.state.avatar} dark={this.state.dark} userStateImg={this.state.userStateImg} gradeInfo={this.state.gradeInfo} level={this.state.level} difListenCount={this.state.difListenCount} listenCount={this.state.listenCount}/>
          <Medal medalData={this.state.medalData} dark={this.state.dark} medalDataLength={this.state.medalDataLength}/>
          <MyWeal dark={this.state.dark} ref="myWeal"/>
        </div>
      </div>
    )
  }
}

export default Achievement;
